import React from 'react'

import { useSelector } from 'react-redux'

import { IApplicationState } from '@store'
import { selectShareableContentLibraryMediaObjectIds } from '@store/mediaObjects'
import { Container } from '@tribegroup'
import { isEmpty } from '@utils'
import { ShareThisLibrary } from '../Buttons'
import { HeaderLogo, HeaderSubtitle, HeaderTitle } from '.'

const ShareableContentLibraryHeader: React.FC = () => {
  const hasEmptyLibrary = useSelector((state: IApplicationState) =>
    isEmpty(selectShareableContentLibraryMediaObjectIds(state)),
  )
  return (
    <React.Fragment>
      <Container topOuterSpacing={3.875}>
        <HeaderLogo />
      </Container>
      <Container topOuterSpacing={1.5}>
        <HeaderTitle />
      </Container>
      <Container topOuterSpacing={0.75}>
        <HeaderSubtitle />
      </Container>
      {!hasEmptyLibrary && (
        <Container topOuterSpacing={1.25}>
          <ShareThisLibrary />
        </Container>
      )}
    </React.Fragment>
  )
}

export { ShareableContentLibraryHeader }
export default ShareableContentLibraryHeader
